import { Box, CircularProgress } from "@mui/material";

/**
 * Lazy yüklenen route'lar indirilirken gösterilen ara yükleyici.
 */
const RouteFallback = () => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "60vh",
    }}
  >
    <CircularProgress />
  </Box>
);

export default RouteFallback;
